// CameraModal.jsx

import React, { useCallback } from 'react';

// Hooks
import { useIsMobile } from 'hooks/useDeviceDetect';

// Components
import Modal from 'components/modal/Modal';
import Camera from './Camera';

/**
 * CameraModal
 *
 * Displays a modal containing the Camera component.
 *
 * @param {boolean} isOpen - Whether the modal is open.
 * @param {function} setOpen - Function to set the open state.
 * @param {string} contentType - 'SNAPSHOT' or 'RECORDING'.
 * @param {function} onContentCreated - Callback when content is created.
 *
 * @returns {ReactNode} The rendered component.
 */
const CameraModal = ({
  isOpen,
  setOpen,
  contentType,
  onContentCreated,
}) => {

  // ----- HOOKS ----- //

  const isMobile = useIsMobile();

  // ----- UTILITIES ----- //

  const modalWidth = isMobile ? '100%' : 800;
  const modalHeight = isMobile ? '100%' : 600;

  // ----- HANDLERS ----- //

  /**
   * Closes the camera modal.
   */
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  // ----- RENDER ----- //

  return (
    <Modal
      isOpen={isOpen}
      width={modalWidth}
      height={modalHeight}
      showHeader={false}
      enableClose={true}
      padding="0"
      onClose={handleClose}
    >
      {/* CAMERA CONTENT */}
      <div style={{ width: '100%', height: '100%' }}>
        <Camera
          contentType={contentType}
          onContentCreated={onContentCreated}
        />
      </div>
    </Modal>
  );
};

// Dev Tools
CameraModal.displayName = 'CameraModal';

export default CameraModal;
